import { CategorySpecResponse, CategorySuggestionList, ChannelListingListResponse, ChannelPublishResponse, ItemVariationListResponse, ListingPriceResponse, SalesChannelListResponse, SalesChannelSummary, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchSalesChannels = async (companyId, signal) => {
    const params = new URLSearchParams();
    if (companyId !== undefined)
        params.set('companyId', companyId);
    const encoded = params.toString();
    return SalesChannelListResponse.parse(await request(`/api/v1/channels${encoded.length > 0 ? `?${encoded}` : ''}`, { signal }));
};
export const createSalesChannel = async (input) => SalesChannelSummary.parse(await request('/api/v1/channels', { method: 'POST', body: input }));
export const updateSalesChannel = async (id, input) => SalesChannelSummary.parse(await request(`/api/v1/channels/${id}`, { method: 'PATCH', body: input }));
export const fetchChannelListings = async (channelId, signal) => ChannelListingListResponse.parse(await request(`/api/v1/channels/${channelId}/listings`, { signal }));
export const createChannelListing = async (channelId, input) => (await request(`/api/v1/channels/${channelId}/listings`, {
    method: 'POST',
    body: input,
}));
/** As variações de um anúncio que já existe no canal (F177). */
export const fetchItemVariations = async (channelId, externalId, productId, signal) => {
    const query = productId === null ? '' : `?productId=${productId}`;
    return ItemVariationListResponse.parse(await request(`/api/v1/channels/${channelId}/items/${encodeURIComponent(externalId)}/variations${query}`, { signal }));
};
export const setChannelListingStatus = async (channelId, listingId, input) => {
    await request(`/api/v1/channels/${channelId}/listings/${listingId}`, {
        method: 'PATCH',
        body: input,
    });
};
/** Computed on request; there is no stored published quantity to read. */
export const fetchPublishable = async (channelId, listingId, signal) => ChannelPublishResponse.parse(await request(`/api/v1/channels/${channelId}/listings/${listingId}/publishable`, { signal }));
/* -------------------------------------------------------------------------
 * A ficha do anúncio (F111)
 * ---------------------------------------------------------------------- */
/**
 * Em que categoria do canal este produto entraria.
 *
 * O preditor do Mercado Livre responde sem credencial, então isto funciona
 * numa loja que ainda não conectou a conta — é a metade do trabalho que não
 * depende de conta nenhuma.
 */
export const fetchCategorySuggestions = async (channelId, query, signal) => {
    const params = new URLSearchParams({ title: query.title });
    if (query.brand != null && query.brand.length > 0) {
        params.set('brand', query.brand);
    }
    return CategorySuggestionList.parse(await request(`/api/v1/channels/${channelId}/category-suggestions?${String(params)}`, { signal }));
};
/** O que o canal exige nesta categoria: atributos, limites, condições. */
export const fetchCategorySpec = async (channelId, categoryRef, signal) => CategorySpecResponse.parse(await request(`/api/v1/channels/${channelId}/categories/${encodeURIComponent(categoryRef)}`, { signal }));
/** Salva a ficha inteira. Tudo que entra aqui foi digitado: origem `manual`. */
export const saveChannelListingDraft = async (channelId, listingId, input) => {
    await request(`/api/v1/channels/${channelId}/listings/${listingId}/draft`, {
        method: 'PATCH',
        body: input,
    });
};
/** Por quanto o anúncio sairia, e por quê. Cota o canal ao vivo. */
export const fetchListingPrice = async (channelId, listingId, signal) => ListingPriceResponse.parse(await request(`/api/v1/channels/${channelId}/listings/${listingId}/price`, {
    signal,
}));
//# sourceMappingURL=channels.js.map